<template>
<div class="ucp__menu">

  <div class="ucp__maintitle">Меню</div>
  <div class="ucp__formsubtitle">Личный ящик</div>
  <p>
    · <a><b>Новое письмо</b></a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> - <a href="index.php?act=Msg">Inbox
      <template v-if="inbox > 0">
        ({{inbox}})
      </template>
    </a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> - <a href="index.php?act=Msg&VID=sent">Sent Items
      <template v-if="outbox > 0">
        ({{outbox}})
      </template>
    </a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> - <a href="index.php?act=Msg&VID=unsent">Неотправленные
      <template v-if="unsent > 0">
        ({{unsent}})
      </template>
    </a><br>
    · <a>Очистка папок</a><br>
    · <a>Редактировать папки</a><br>
    · <a>Редактировать игнорлист</a><br>
    · <a>Список Друзей/Врагов</a><br>
    · <a>Архивация писем</a><br>
    · <a>Слежение за письмами</a><br>
  </p>

  <div class="ucp__formsubtitle">Подписки</div>
  <p>
    · <a>Темы</a><br>
    · <a>Форумы</a><br>
  </p>

  <div class="ucp__formsubtitle">Ваш профиль</div>
  <p>
    · <a>Редактировать профиль</a><br>
    · <a>Редактировать подпись</a><br>
    · <a>Настройки аватара</a><br>
    · <a>Изменение фотографии</a><br>
  </p>

  <div class="ucp__formsubtitle">Настройки</div>
  <p>
    · <a>Настройки e-mail</a><br>
    · <a>Настройки форума</a><br>
    · <a>Скины и Языки</a><br>
    · <a>Изменить e-mail адрес</a><br>
    · <a>Изменить пароль</a><br>
  </p>

</div>
</template>

<script>
export default {
  props: ['inbox', 'outbox', 'unsent'], // now use {{breadcrumbs}}
}
</script>

<style lang="scss">
.ucp__menu {
    background: #1b153b;
    border: 1px solid #000;
    line-height: 148%;
    p {
        margin: 0;
        padding: 2px 5px 6px 9px;
    }
}
.ucp__maintitle {
    background-image: linear-gradient(#000c5b, #1055a8);
    border: 1px solid #345487;
    border-bottom: 1px solid #303088;
    font-size: 12px;
    margin: 0;
    padding: 8px;
    color: #ffff00;
}
.ucp__formsubtitle {
    background-image: linear-gradient(#09146a, #122f77);
    font-weight: bold;
    padding: 5px;
    font-size: 11px;
    color: #ffff00;
}
</style>
